var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      pad: "0",
      title: _vm.$t("label_essweb_ClaimRecord_list_title"),
      filterable: "",
      exportBtn: _vm.hasBtn("export-admin-claim-record"),
      importBtn: _vm.hasBtn("import-admin-claim-record"),
      "import-options": {
        api: "/claim-records/import/",
        templateUrl:
          "https://assets.essencehr.io/web/ess-business/assets/claim-transaction-record-import-template.xlsx",
        success: function (result) {
          _vm.getList(null, 1, _vm.$tableSetting.perPageSize, function () {
            _vm.$store.dispatch("resetTable", new Date().getTime())
          })
        },
      },
    },
    on: {
      filter: function (val) {
        _vm.filterPageData = val
      },
      export: _vm.onExport,
    },
    scopedSlots: _vm._u([
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c("Selections2", {
              attrs: { objects: _vm.filterObjects, "small-chip": "" },
              on: {
                filter: function ($event) {
                  filter()
                  _vm.toFilter(filter)
                },
                update: function (prop, value, selected) {
                  _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                },
                reset: function (apply) {
                  _vm.$fliterValue(_vm.filterObjects, null, null)
                  if (apply) {
                    filter()
                    _vm.toFilter(filter)
                  }
                },
              },
            }),
          ]
        },
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                height: _vm.$vuetify.breakpoint.height - 275 - 48,
                showSelect: _vm.showSelect,
                totalCount: _vm.totalCount,
                "filter-page-data": _vm.filterPageData,
                overLoading: "",
              },
              on: {
                change: function (page, perpage, callback, data) {
                  _vm.getList(data, page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.applicant",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        { staticStyle: { "max-width": "300px" } },
                        [
                          item.agent_staff
                            ? _c(
                                "v-list-item",
                                {
                                  staticClass: "pa-0",
                                  attrs: { dense: "", "two-line": "" },
                                },
                                [
                                  _c(
                                    "v-list-item-avatar",
                                    {
                                      staticClass: "mr-1 my-0",
                                      attrs: { size: "36" },
                                    },
                                    [
                                      _c("StaffAvatar", {
                                        attrs: {
                                          size: "36",
                                          src: item.agent_staff.staff_avatar,
                                          staff_name:
                                            item.agent_staff.preferred_name,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticClass:
                                            "table-title text--primary",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  item.agent_staff
                                                    .preferred_name
                                                )
                                              ) +
                                              " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text--secondary text-caption-xs",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.agent_staff.staff_code
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-list-item-subtitle",
                                        {
                                          staticClass:
                                            "table-subtitle text--secondary",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  item.agent_staff.job_post_name
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.swift_number",
                  fn: function (ref) {
                    var item = ref.item
                    return [_vm._v(" " + _vm._s(item.swift_number) + " ")]
                  },
                },
                {
                  key: "item.claim_form_name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$getCommonLangValue(item.claim_form_name)
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "item.amount",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        _vm._s(item.currency_code) +
                          " " +
                          _vm._s(_vm.$get_thousand_num(item.claim_total_amount))
                      ),
                    ]
                  },
                },
                {
                  key: "item.date",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$getDateTime(
                              item.submission_utc_datetime,
                              "YYYY/MM/DD"
                            )
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "item.pay_status",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      Number(item.payment_status_uuid) === 1
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "div",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticStyle: { width: "24px" },
                                              },
                                              "div",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c("svg-icon", {
                                              attrs: {
                                                size: "24",
                                                fill: "transparent",
                                                iconClass:
                                                  Number(
                                                    item.payment_status_uuid
                                                  ) === 1
                                                    ? "Done"
                                                    : "",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "label_essweb_ClaimRecord_form_paymentCompleteLabel"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "item.status",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("StatusChip", {
                        attrs: {
                          slideColor: item.approval_tint_color,
                          bgColor: item.approval_bg_color,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "status",
                              fn: function () {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          item.status_detail
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm.hasBtn("view-admin-claim-record")
                        ? _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.toView(item.uuid)
                                },
                              },
                            },
                            [
                              _c("svg-icon", {
                                attrs: {
                                  size: "24",
                                  fill: "currentColor",
                                  iconClass: "viewDetail",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }